export default __webpack_public_path__ + "static/media/questions.7e4043cf.svg";